// Neutral colors are local to the API page; other marketing pages keep their palette.
export function apiPalette(isDark) {
  return isDark ? {
    page: '#111112', surface: '#1C1C1E', soft: '#19191B', ink: '#F5F5F7',
    secondary: '#B5B5BD', muted: '#9898A1', rule: '#333336', hover: '#28282B',
  } : {
    page: '#FFFFFF', surface: '#FFFFFF', soft: '#F5F5F7', ink: '#1D1D1F',
    secondary: '#626269', muted: '#727279', rule: '#E4E4E8', hover: '#EBEBEF',
  };
}
